<template>
  <div>
    <div class="titleWrapper">
      <van-image :src="require('@/assets/img/log1.png')" />
    </div>
    <!-- 登陆 -->
    <div class="loginShop" v-if="isShow">
      <div class="login">
        <van-form @submit="onLogin">
          <van-field
            v-model="nameLogin"
            label="用户名"
            placeholder="请输入用户名"
            :rules="[{ required: true, message: '*' }]"
          />
          <van-field
            v-model="passwordLogin"
            type="password"
            label="密码"
            placeholder="密码"
            :rules="[{ required: true, message: '*' }]"
          />
          <div style="margin: 16px">
            <van-button round block type="danger" native-type="submit">
              立即登录
            </van-button>
          </div>
        </van-form>
      </div>
      <!-- 跳转注册 -->
      <!-- <div class="switherWrapper">
        <span>
          {{ $lang["还没有账号"] }}?
          <i @click="register()">{{ $lang["注册"] }}</i>
        </span>
      </div> -->
    </div>
    <!-- 注册 -->
    <div class="register" v-else>
      <div class="login">
        <van-form @submit="onRegister">
          <van-field
            v-model="userRegister"
            name="pattern "
            :label="$lang['用户名称']"
            :placeholder="$lang['请输入用户名称']"
            :rules="[
              {
                trigger: 'onBlur',
                required: true,
              },
              {
                trigger: 'onChange',
                pattern,
                message: this.$lang[
                  '以字母开头，不能有特殊符号，长度限制在4-16位'
                ],
              },
            ]"
          />

          <van-field
            v-model="passwordRegister"
            type="password"
            name="validator"
            :label="$lang['密码']"
            :placeholder="$lang['请输入密码']"
            :rules="[
              {
                trigger: 'onBlur',
                required: true,
              },
              {
                trigger: 'onChange',
                validator,
                message: this.$lang[
                  '由字母和数字组成，区分大小写，长度限制为6-12'
                ],
              },
            ]"
          />
          <van-field
            v-model="passnewReg"
            type="password"
            :label="$lang['确认密码']"
            :placeholder="$lang['请再一次填写密码']"
            :rules="[
              {
                required: true,
                message: this.$lang['请再一次填写密码'],
                trigger: 'onBlur',
              },
            ]"
          />
          <van-field
            v-model="tel"
            name="validator1"
            type="text"
            :label="$lang['电话号码']"
            :placeholder="$lang['请输入电话号']"
            :rules="[
              {
                required: true,
                trigger: 'onBlur',
              },
              {
                trigger: 'onChange',
                validator: validator1,
                message: this.$lang['请输入正确的电话号码'],
              },
            ]"
          />
          <van-field
            v-model="value2"
            name="validator2"
            :label="$lang['护照号']"
            :placeholder="$lang['请输入护照号']"
            :rules="[
              {
                required: true,
                trigger: 'onBlur',
              },
              {
                trigger: 'onChange',
                validator: validator2,
                message: this.$lang['请输入正确的护照号'],
              },
            ]"
          />
          <div style="margin: 16px">
            <van-button round block type="danger" native-type="submit">
              {{ this.$lang["立即注册"] }}
            </van-button>
          </div>
        </van-form>
      </div>
      <!-- 跳转注册 -->
      <div class="switherWrapper">
        <span>
          <i @click="register()">{{ $lang["已经有账号"] }}</i>
        </span>
      </div>
    </div>
    <!-- <van-dialog
      v-model="showPoints"
      show-cancel-button
      :confirmButtonText="$lang['确认']"
      :cancel-button-text="$lang['取消']"
      @confirm="onConfirm"
    >
      <van-cell-group>
        <van-cell
          :value="$lang['请确认电话号码是否正确，方便卖家与您联系'] + tel"
        />
      </van-cell-group>
    </van-dialog> -->
  </div>
</template>

<script>
// import { Toast } from "vant";
export default {
  data() {
    return {
      showPoints: false,
      nameLogin: "",
      passwordLogin: "",
      userRegister: "",
      passwordRegister: "",
      passnewReg: "",
      pattern: /^[a-zA-Z\xa0-\xff_][0-9a-zA-Z\xa0-\xff_]{3,17}$/, //用户名正则校验
      isShow: true,
      registerflag: false,
      tel: "",
      value2: "",
    };
  },
  //inject: ["loadCartList"],

  created() {},
  methods: {
    onClickLeft() {
      this.$router.back(-1);
    },
    //用户名验证
    // pattern(val){
    //   return /^[a-zA-Z0-9_-]{3,16}$/.test(val);//用户名正则校验
    // },
    // 护照号不能为空校验函数返回 true 表示校验通过，false 表示不通过
    validator2(val) {
      return /\S/.test(val);
    },
    // 注册密码正则校验
    validator(val) {
      return /^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9]{6,12}$/.test(val);
    },
    // 电话正则校验
    validator1(val) {
      return /^\d{11}$/.test(val);
    },

    register() {
      this.isShow = !this.isShow;
    },

    login() {
      this.$request
        .login({ username: this.nameLogin, password: this.passwordLogin })
        .then((res) => {
          if (res.code == 0) {
            this.$store.commit("setToken", res.data.token);
            this.$store.dispatch("syncUpdateUserInfo").then((res) => {
              
              if (res.code == 0 && res.data.password == "123456") {
                this.$toast({
                  message: "请修改原始密码",
                });
                
                this.$router.push("/my/personsetting");
              }
            });
            
            this.$router.push("/crm");
          } else {
            this.$toast({
              message: `${this.$lang["用户名或密码错误"]}`,
            });
          }
        });
    },
    // 登陆
    onLogin() {
      this.login();
    },
    // 点击支付弹窗确认时触发
    onConfirm(value, index) {
      this.submitRegister();
    },
    // 注册
    onRegister() {
      if (this.passwordRegister != this.passnewReg) {
        this.$toast({
          message: `${
            this.$lang["两次输入密码不同"] + "，" + this.$lang["请重新输"]
          }`,
        });
        return;
      }
      if (this.tel == "") {
        this.$toast({
          message: this.$lang["请输入正确的电话号码"],
        });
        return;
      }
      this.showPoints = true;
    },
    submitRegister() {
      this.$request
        .register({
          username: this.userRegister,
          password: this.passnewReg,
          roles: ["c"],
          tel: this.tel,
          myAddress: [],
        })
        .then((res) => {
          if (res.code == 0) {
            this.nameLogin = this.userRegister;
            this.passwordLogin = this.passnewReg;
            this.$toast({
              message: `${this.$lang["注册成功"]}`,
            });

            this.login();
          }
          if (res.code == 1) {
            this.$toast({
              message: `${this.$lang["该账号已注册"]}`,
            });
          }
        });
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.titleWrapper {
  padding: 50px 0px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .title {
    font-size: 28px;
    font-weight: 600;
    color: #666;
  }

  .methods {
    font-size: 18px;
    font-weight: normal;
  }
}

.login {
  padding: 10px 16px;
}

.switherWrapper {
  font-size: 12px;
  color: #999;
  display: flex;
  justify-content: center;
  align-items: center;

  i {
    color: red;
    font-style: normal;
  }
}
</style>